import React, { cloneElement, createContext, useEffect, useState, useRef } from 'react'
import { ThemeProvider } from 'styled-components/macro'
import { Redirect, Route } from 'react-router-dom'
import theme from '../styles/theme'
import { Main } from '../styles/'
import { getLoyalty } from '../api'
import Loading from '../views/common/Loading'
import { defaultLanguage } from '../utils/language'

const language = localStorage.getItem('language') || defaultLanguage

const languageTexts = require(`../locale/${language || 'fa'}`).default
export const LocaleContext = createContext(languageTexts)

const useLoyalty = (currentlyRegistered, isGiftPaid) => {

  const [loyalty, setLoyalty] = useState()
  const [loading, setLoading] = useState()

  useEffect(() => {
    const getUserLoyalty = async () => {
      setLoading(true)
      const userLoyalty = await getLoyalty()
      setLoyalty(userLoyalty)
      setLoading(false)
    }
    getUserLoyalty()
  }, [currentlyRegistered, isGiftPaid])
  return [loyalty, loading]
}

const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export default ({ children, ...rest }) => {
  const currentPath = rest.path
  const previousPath = usePrevious(currentPath)

  const currentlyRegistered = currentPath === "/" && previousPath === "/register"
  const isRegistering = currentPath === "/register"

  const isGiftPaid =
    (window && window.location && window.location.pathname && window.location.pathname.includes("/gift/paid")) ||
    (currentPath === "/store" && previousPath && previousPath.includes("/gift"))
  const [loyalty, loading] = useLoyalty(currentlyRegistered, isGiftPaid)
  const alreadyRegistered = loyalty && loyalty.status

  const isAuthorized = loyalty &&
    (alreadyRegistered || currentlyRegistered || isRegistering)

  return (
    <Route
      {...rest}
      render={() =>
        <ThemeProvider theme={theme}>
          <LocaleContext.Provider value={languageTexts}>
            {loading ?
              <Loading />
              :
              loyalty && (
                isAuthorized ?
                  <Main>
                    {cloneElement(children, { loyalty })}
                  </Main>
                  :
                  <Redirect to="/register" />
              )
            }
          </LocaleContext.Provider>
        </ThemeProvider>
      }
    />
  )
}